import { TmcContextService } from './../../../../common/tmc-context.service';
import { ActivatedRoute, } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { AbstractWidgetComponent,  AppClientConfiguration,  AppServerAPI,  WidgetScale, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { ActionTabletContext } from '../model/action-tablet-context';
import { Station } from '../../../../client/model/station';
import { interval, Subscription } from 'rxjs';
import { CAvailableMovementOrders, CMovementOrder } from '../model/action-tablet.model';

@Component({
    selector: 'app-station-tablet',
    templateUrl: './action-tablet.component.html',
    styleUrls: ['./action-tablet.component.scss'],
    standalone: false
})
export class ActionTabletComponent extends AbstractWidgetComponent implements OnDestroy {

  private initialized = false;

  private tmcContextServiceUpdateSubscription: Subscription = null;

  private currentlyActiveStationChangedSubscription: Subscription = null;

  enableStationSelectionHeader = false;

  actionTabletContext = new ActionTabletContext();

  selectedStation: Station = null;

  waitingMovementOrders = new Array<CMovementOrder>();

  refreshEnabled = true;
  refreshInterval = null;
  refreshTimer: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private tmcContextService: TmcContextService,
    private appServerAPI: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration
  ) {
    super();

    // Auf Stationsauswahl im Tablet Header reagieren.
    this.currentlyActiveStationChangedSubscription = this.actionTabletContext.currentlyActiveStationChanged.subscribe(stationId => {
      this.selectedStation = this.tmcContextService.findStationById(stationId);
      this.loadWaitingMovementOrders();
    });

    // Moeglich, dass die Stations im Context noch nicht geladen sind, aber bereits die Stationsauswahl triggert.
    this.tmcContextServiceUpdateSubscription = this.tmcContextService.updated.subscribe(yardConfig => {
      if (this.initialized === false && yardConfig != null) {
        this.initialized = true;
        this.checkAndApplySelectedStation();
        this.actionTabletContext.contextReady.next();
      }
    });
  }

  ngOnDestroy() {
    this.currentlyActiveStationChangedSubscription.unsubscribe();
    this.tmcContextServiceUpdateSubscription.unsubscribe();
    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
  }


  onSetElementAndContext() {
    this.actionTabletContext.widgetIdentifier = this.widgetIdentifier;

    this.refreshEnabled = this.widgetReference.data?.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 30 * 1000;
    }
    this.registerRefreshTimer();
  }

  onContextChange(contextChange: ContextChange) {
  }

  getScale(): WidgetScale {
    return WidgetScale.triple;
  }


  private registerRefreshTimer() {

      if (this.refreshTimer) {
        this.refreshTimer.unsubscribe();
      }

      if (this.appClientConfiguration.autoreload && this.refreshEnabled) {
        this.refreshTimer = interval(this.refreshInterval).subscribe(n => {
          this.loadWaitingMovementOrders();
        });
      }
    }

  private checkAndApplySelectedStation() {
    const stationIdentifier = this.activatedRoute.snapshot.queryParamMap.get('stationIdentifier');
        if (stationIdentifier != null) {
          this.enableStationSelectionHeader = false;
          this.selectedStation = this.tmcContextService.findStationByIdentifier(stationIdentifier);
          this.actionTabletContext.currentlyActiveStation = this.selectedStation?.id;
        } else {
          this.enableStationSelectionHeader = true;
        }
  }

  private loadWaitingMovementOrders() {
      if (this.selectedStation == null) {
        return;
      }
      this.appServerAPI.execute<CAvailableMovementOrders>('/client/control/action-tablet/load-movement-orders-for-station', { id: this.selectedStation.id}).subscribe(result => {
        const loadedMovementOrders = new Array<CMovementOrder>();
        result.movementOrders.forEach(movementOrder => loadedMovementOrders.push(new CMovementOrder(movementOrder)));
        this.waitingMovementOrders = loadedMovementOrders;
      });
    }


  getStyle(): WidgetStyle {
      return WidgetStyle.transparent;
  }

}
